/* Bloom: geeft elke kennisbankkaart de tint van zijn categorie, en laat de
   achtergrondgloed meekleuren met de categorie die je hebt aangeklikt.

   De categorie staat als tekst in de kaart (.kbf-cat op de landingspagina,
   .kbz-icat op de zoekpagina) en CSS kan niet op tekstinhoud selecteren. Daarom
   zetten we hier een data-kb-tint op de kaart; snippets/bloom-kennisbank-stijl.liquid
   hangt daar de kleuren aan.

   De zoekpagina bouwt haar resultaten met eigen JavaScript uit KBZ_DATA, en laadt
   bij op de knop "toon meer". Een eenmalige ronde bij het laden is dus niet genoeg;
   een MutationObserver kleurt bij elke nieuwe lichting mee. We kijken alleen naar
   childList, dus het zetten van het attribuut start de observer niet opnieuw.

   Voor de gloed lezen we niet de globale kbzState maar de knop met de klasse
   'active' in #kbz-cats. Dat is dezelfde bron die de pagina zelf gebruikt om de
   filterknop op te lichten, dus de gloed kan er nooit naast zitten. De klik-
   afhandeling van de pagina zit als inline onclick op de knop en draait dus af
   voordat de klik bij de zijbalk aankomt; als wij daar meeluisteren staat 'active'
   al goed. */

(function () {
  /* Alle dertien categorieen uit KBZ_CATS, verdeeld over vier tinten.

     De vierde tint was eerst pruim, maar dat werkt niet: pruim lichter maken loopt
     altijd richting grijsroze, en die gloed was op het creme nog maar dE 4,9 van de
     roze verwijderd. Onder ongeveer dE 5 ziet het oog geen verschil, dus Slaap,
     Opvoeding, Gezondheid en Gezin gaven helemaal geen zichtbare kleurwissel. Lila
     ligt qua tint verder weg en houdt op alle paren minstens dE 12 afstand.

     De verdeling is verder zo gekozen dat de drie uitgelichte artikelen op de
     landingspagina (Kraamtijd, Slaap, Zelfzorg) elk een andere tint krijgen -
     anders staan daar twee dezelfde naast elkaar. Verwante onderwerpen delen een
     tint, zodat een lange lijst rustig blijft. */
  var TINTEN = {
    zwangerschap: 'roze',
    kraamtijd: 'roze',
    relatie: 'roze',
    baby: 'goud',
    peuter: 'goud',
    school: 'goud',
    voeding: 'salie',
    ontwikkeling: 'salie',
    zelfzorg: 'salie',
    slaap: 'lila',
    opvoeding: 'lila',
    gezondheid: 'lila',
    gezin: 'lila'
  };

  var REEKS = ['roze', 'goud', 'salie', 'lila'];

  function kiesTint(label, positie) {
    var naam = (label || '').trim().toLowerCase();
    return TINTEN[naam] || REEKS[positie % REEKS.length];
  }

  function kleurKaarten() {
    var kaarten = document.querySelectorAll('.kbf-item, .kbz-item');

    for (var i = 0; i < kaarten.length; i++) {
      var label = kaarten[i].querySelector('.kbf-cat, .kbz-icat');
      kaarten[i].setAttribute('data-kb-tint', kiesTint(label && label.textContent, i));
    }
  }

  /* Zonder gekozen categorie (de knop "Alle") halen we het attribuut weg, zodat de
     gloed terugvalt op het zachte roze uit het stylesheet. */
  function zetGloed() {
    var actief = document.querySelector('#kbz-cats .kbz-fb.active');
    var categorie = actief ? actief.getAttribute('data-cat') : '';

    if (categorie) {
      document.documentElement.setAttribute('data-kb-gloed', kiesTint(categorie, 0));
    } else {
      document.documentElement.removeAttribute('data-kb-gloed');
    }
  }

  function start() {
    kleurKaarten();
    zetGloed();

    var zijbalk = document.querySelector('.kbz-sb');
    if (zijbalk) zijbalk.addEventListener('click', zetGloed);

    var resultaten = document.querySelector('.kbz-res');
    if (!resultaten) return;

    new MutationObserver(kleurKaarten).observe(resultaten, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
